export const trim = (str: string, length: number, sufix?: string) => {
  const result = str.length > length ? str.substr(0, length) : str;
  return `${result}${str.length > length && sufix ? sufix : ''}`;
};
